import { tempoApi } from '@/common/api/tempoApi';
import type { Objective, PaginatedObjectives } from '@/common/api/types/objectives';

const getObjectives = async ({
  loopId,
  limit,
  cursor,
}: {
  loopId?: number;
  limit?: number;
  cursor?: string;
} = {}): Promise<PaginatedObjectives> => {
  const searchParams = new URLSearchParams();
  if (loopId !== undefined) searchParams.set('loopId', String(loopId));
  if (limit !== undefined) searchParams.set('limit', String(limit));
  if (cursor) searchParams.set('cursor', cursor);
  return tempoApi()
    .get('api/v1/item-store/objectives', { searchParams })
    .json<PaginatedObjectives>();
};

const getObjective = async (id: number): Promise<Objective> =>
  tempoApi().get(`api/v1/item-store/objectives/${id}`).json<Objective>();

const createObjective = async (data: { title: string }): Promise<Objective> =>
  tempoApi().post('api/v1/item-store/objectives', { json: data }).json<Objective>();

const updateObjective = async (id: number, data: { title: string }): Promise<Objective> =>
  tempoApi().put(`api/v1/item-store/objectives/${id}`, { json: data }).json<Objective>();

const deleteObjective = async (id: number): Promise<void> => {
  await tempoApi().delete(`api/v1/item-store/objectives/${id}`);
};

export const ObjectivesApi = {
  getObjectives,
  getObjective,
  createObjective,
  updateObjective,
  deleteObjective,
} as const;
